import { useMemo, useState } from 'react'
import { PropertyDetail, ReactSimpleComponentProps } from '@/custom-types'
import { PropertyDetailsContext } from './PropertyDetailsContext'

export const PropertyDetailsContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [state, setState] = useState<PropertyDetail | undefined>(undefined)

  const actions = useMemo(() => ({
    setProperty: (property: PropertyDetail | undefined) => setState(property),
  }), [])

  return (
    <PropertyDetailsContext.Provider value={{...actions, property: state}}>
      {children}
    </PropertyDetailsContext.Provider>
  )
}